import { Dialog, IconButton, Stack, Typography } from '@mui/material';
import { X } from 'lucide-react';

import { useEffect, useState } from 'react';
import { Loader } from '@treedis/tour-loader/dist';
import { FileDialogProps } from './types';

const FileDialog = (props: FileDialogProps) => {
  const { open, setOpen, title, document, type, tourId } = props;

  const [iframeLoaded, setIframeLoaded] = useState<boolean>(false);
  const [retryCount, setRetryCount] = useState<number>(0);

  // Check if document is already a full URL or just a filename
  const isFullUrl = document && (document.startsWith('http://') || document.startsWith('https://'));
  const documentUrl = isFullUrl
    ? document
    : `${process.env.NEXT_PUBLIC_CDN}/tours/${tourId}/menus/files/${document}`;

  useEffect(() => {
    let interval;
    if (!iframeLoaded) {
      interval = setInterval(() => {
        setRetryCount((prev) => prev + 1);
      }, 3000);
    }
    return () => clearInterval(interval);
  }, [iframeLoaded]);

  return (
    <Dialog open={open} fullScreen>
      <>
        <Stack
          direction="row"
          spacing={2}
          px={3}
          py={2}
          alignItems="center"
          justifyContent="space-between"
          sx={{ backgroundColor: '#000000CC' }}
        >
          <Typography sx={{ fontSize: '18px', fontWeight: 700, color: '#FFFFFF' }}>
            {title}
          </Typography>
          <IconButton onClick={() => setOpen(!open)}>
            <X size={18} />
          </IconButton>
        </Stack>
        {!iframeLoaded && (
          <Stack
            position="absolute"
            top={0}
            left={0}
            width="100%"
            height="100%"
            alignItems="center"
            justifyContent="center"
          >
            <Loader />
          </Stack>
        )}
        <iframe
          src={`https://docs.google.com/viewer?url=${encodeURIComponent(documentUrl)}&embedded=true&preview=true`}
          key={retryCount}
          // src={gallery[0].filePath}
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
          title="PDF Viewer"
          width="100%"
          height="100%"
          style={{
            width: '100%',
            height: '100%',
            minHeight: '190px',
            visibility: iframeLoaded ? 'visible' : 'hidden',
            aspectRatio: '1920/1080',
          }}
          onLoad={() => {
            setIframeLoaded(true);
          }}
          onError={(e) => console.log('iframe error', e)}
        />
      </>
    </Dialog>
  );
};

export default FileDialog;